import { Stack, Typography } from '@mui/material';
import React from 'react';
import type { ColorResult } from 'react-color';
import { defaultBrandedColors } from 'src/constants';
import { useUserRole } from 'src/utils';

import { WidgetsCommonProps } from '../widget.interface';
import { rgbaToHex8 } from './ColorPickerWidget.helper';
import {
  ColorWidgetHelperText,
  Container,
  InputLabel,
} from './ColorPickerWidget.styled';
import { ColorPickerContent } from './modules/ColorPickerContent';

export const ColorPickerWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const { isViewOnly } = useUserRole();

    const handleColorChange = (color: ColorResult) => {
      if (!isViewOnly) {
        props.onChange(rgbaToHex8(color.rgb) || '');
      }
    };

    return (
      <Container ref={ref}>
        <InputLabel>{props.label}</InputLabel>

        <Stack alignItems="center">
          <ColorPickerContent
            value={props.value}
            showBackgroundColor={!!props.options?.backgroundColor}
            pickerWrapperStyle={props?.pickerWrapperStyle}
            defaultColors={props?.defaultColors ?? defaultBrandedColors}
            colorPickerMode={props.colorPickerMode}
            isViewOnly={isViewOnly}
            onChange={handleColorChange}
            showBorder={!!props.options?.border}
            triangle={props.options?.triangle}
          />

          {props.options?.showHEX && <Typography>{props.value}</Typography>}
        </Stack>

        {props.hasError && (
          <ColorWidgetHelperText error={props.hasError}>
            {props.hasError ? props.error : undefined}
          </ColorWidgetHelperText>
        )}
      </Container>
    );
  },
);
